import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'MailSearch',
    standalone: false
})
export class MailSearchPipe implements PipeTransform {
  transform(value: Array<any>, args?: string): Array<any> {
    if (!value) return [];
    if (!args || args.trim() === '') return value;

    let searchText: RegExp;
    try {
      searchText = new RegExp(args, 'ig');
    } catch (e) {
      return value;
    }

    return value.filter(mail => {
      // Inbox list DTO — flat fields
      const fullName = mail.senderFullName || '';
      const enFullName = mail.senderEnFullName || '';
      const subject = mail.subject || '';

      // Sent list DTO — recipient names array
      const recipientNames = (mail.firstTwoRecipientNames || []).join(' ');

      return fullName.search(searchText) !== -1 ||
             enFullName.search(searchText) !== -1 ||
             subject.search(searchText) !== -1 ||
             recipientNames.search(searchText) !== -1;
    });
  }
}